/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Driver_CpfInputs */

const en_case_field_driver_cpf = /** @type {(inputs: Case_Field_Driver_CpfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax ID (CPF)`)
};

const pt_br2_case_field_driver_cpf = /** @type {(inputs: Case_Field_Driver_CpfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPF`)
};

/**
* | output |
* | --- |
* | "Tax ID (CPF)" |
*
* @param {Case_Field_Driver_CpfInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_driver_cpf = /** @type {((inputs?: Case_Field_Driver_CpfInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Driver_CpfInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_driver_cpf(inputs)
	return pt_br2_case_field_driver_cpf(inputs)
});